import { render } from "./MenubarComp.vue?vue&type=template&id=edc9b5ee&scoped=true"
import script from "./MenubarComp.vue?vue&type=script&lang=js"
export * from "./MenubarComp.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "./MenubarComp.vue?vue&type=style&index=1&id=edc9b5ee&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc9b5ee"]])

export default __exports__